// Scroll preview badge to reviews — works both in the panel and on direct product page
(function() {
  document.addEventListener('click', function(e) {
    var badge = e.target.closest('.jdgm-prev-badge, [class*="jdgm-prev-badge"]');
    if (!badge) return;
    e.preventDefault();
    // Reviews target: inside panel first, then full product page
    var target = document.getElementById('zahav-panel-reviews')
              || document.querySelector('[id*="17795681923fa0ad9d"]')
              || document.querySelector('.jdgm-widget, #jdgm-widget');
    if (!target) return;
    // Scroll the panel scroller if open, otherwise scroll the page
    var panelContent = document.getElementById('zahav-panel-content');
    if (panelContent && panelContent.contains(target)) {
      panelContent.scrollTo({ top: target.offsetTop - 16, behavior: 'smooth' });
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
(function() {
  var preloader = document.getElementById('zahav-preloader');
  if (!preloader) return;
  var hidden = false;
  var pageLoaded = false;
  function hide() {
    if (hidden) return;
    hidden = true;
    preloader.classList.remove('zahav-preloader--visible');
    preloader.classList.add('zahav-preloader--out');
    setTimeout(function() { preloader.remove(); }, 700);
  }
  window.addEventListener('load', function() {
    pageLoaded = true;
    hide();
  });
  // Only reveal the preloader if the page is still loading after 1300ms - a page that's
  // already ready by then never shows it at all, instead of always flashing it briefly.
  setTimeout(function() {
    if (!pageLoaded && !hidden) {
      preloader.classList.add('zahav-preloader--visible');
    }
  }, 1300);
})();
(function() {
  var panel = document.getElementById('zahav-product-panel');
  var backdrop = document.getElementById('zahav-panel-backdrop');
  var content = document.getElementById('zahav-panel-content');
  var closeBtn = document.getElementById('zahav-panel-close');
  var exitBtn = document.getElementById('zahav-panel-exit');
  if (!panel || !backdrop) return;

  var isOpen = false;
  var currentHref = null;
  var panelHistory = [];

  function openPanel(href) {
    if (isOpen && currentHref === href) return;
    if (isOpen && currentHref) {
      panelHistory.push(currentHref);
    }
    currentHref = href;
    if (exitBtn) exitBtn.hidden = panelHistory.length === 0;
    content.innerHTML = '<div style="padding:3rem;text-align:center;color:var(--zahav-taupe);font-family:\'Santral\',Verdana,sans-serif;font-size:0.8rem;letter-spacing:0.1em;">Loading&hellip;</div>';
    content.scrollTop = 0;
    panel.scrollTop = 0;
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    document.body.classList.add('zahav-panel-open');
    isOpen = true;
    history.pushState({ zahavPanel: true, href: href }, '', window.location.pathname + window.location.search + '#panel');

    fetch(href, { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.getElementById('MainContent');
        if (!main) { content.innerHTML = '<div style="padding:2rem">Could not load product.</div>'; return; }

        doc.querySelectorAll('img[loading]').forEach(function(img) { img.setAttribute('loading', 'eager'); });

        var mediaEl = main.querySelector('.product-information__media');
        var detailsEl = main.querySelector('.product-details');
        var recsEl = main.querySelector('product-recommendations');
        var recentlyViewedEl = main.querySelector('[data-zahav-recently-viewed]');
        // Shopify renders section IDs as shopify-section-template--{id}__{key}
        // Use substring match so we don't need the full prefixed ID
        var reviewsEl = doc.querySelector('[id*="17795681923fa0ad9d"]');

        // Panel-loaded products never trigger a real page load, so the normal
        // "record this product as viewed" script never runs — do it here instead.
        if (recsEl && recsEl.dataset && recsEl.dataset.productId) {
          import(window.ZahavPanelAssets.recentlyViewedProducts)
            .then(function(mod) { mod.RecentlyViewed.addProduct(recsEl.dataset.productId); })
            .catch(function() {});
        }

        content.innerHTML = '';
        var grid = document.createElement('div');
        grid.className = 'zahav-panel-grid';

        var mWrap = document.createElement('div');
        mWrap.className = 'zahav-panel-grid__media';

        var dWrap = document.createElement('div');
        // 'shopify-section' class is required here: theme components like <product-price>
        // find their event-listening ancestor via `this.closest('.shopify-section, dialog')`.
        // Without it, they silently never attach their variant-update listener.
        dWrap.className = 'zahav-panel-grid__details shopify-section';

        if (mediaEl) {
          mWrap.appendChild(document.adoptNode(mediaEl));
          // Remove thumbnail nav (numbered <ol>) — only the main gallery <ul> is needed
          mWrap.querySelectorAll('ol').forEach(function(el) { el.remove(); });
          // The gallery never needs to be sticky inside the panel (the panel's own
          // details column handles that). Strip the class outright at the DOM level
          // rather than relying on a CSS override to cancel position:sticky — iOS WebKit
          // has shown rendering/touch-scroll quirks around overriding an *existing*
          // position:sticky via media query on real devices that don't reproduce in
          // desktop emulation, so removing the class entirely avoids that class of bug.
          mWrap.querySelectorAll('.sticky-content').forEach(function(el) {
            el.classList.remove('sticky-content');
          });
          // Keep the swipe gallery but force it to start on slide 0.
          // The slideshow custom element sets scrollLeft after connectedCallback,
          // so we poll for 800ms to override it until user interaction takes over.
          (function() {
            var scroller = mWrap.querySelector('slideshow-slides');
            if (!scroller) return;
            scroller.scrollLeft = 0;
            var n = 0;
            var guard = setInterval(function() {
              scroller.scrollLeft = 0;
              if (++n >= 8) clearInterval(guard);
            }, 100);
          })();
          // Strip product link hrefs so gallery clicks open the lightbox instead of navigating
          mWrap.querySelectorAll('a[href]').forEach(function(a) {
            try {
              var u = new URL(a.href, window.location.origin);
              if (/^\/products\//.test(u.pathname)) a.removeAttribute('href');
            } catch(ex) {}
          });
        }
        if (detailsEl) dWrap.appendChild(document.adoptNode(detailsEl));

        grid.appendChild(mWrap);
        grid.appendChild(dWrap);
        content.appendChild(grid);

        // Recommendations — appear before reviews
        var recsWrap = document.createElement('div');
        recsWrap.className = 'zahav-panel-recs';
        content.appendChild(recsWrap);

        if (recsEl) {
          var recsParent = recsEl.parentElement;
          recsWrap.appendChild(document.adoptNode(
            (recsParent && recsParent !== main) ? recsParent : recsEl
          ));
        }

        // Recently Viewed — the section itself is never fetched/executed by the browser
        // when it's just moved into the panel via adoptNode (inserted <script> tags don't
        // auto-run), so re-run its init manually once it's in place.
        if (recentlyViewedEl) {
          var rvWrap = document.createElement('div');
          rvWrap.className = 'zahav-panel-recently-viewed';
          rvWrap.appendChild(document.adoptNode(recentlyViewedEl));
          content.appendChild(rvWrap);
          import(window.ZahavPanelAssets.zahavRecentlyViewed)
            .then(function(mod) { mod.init(recentlyViewedEl); })
            .catch(function() {});
        }

        // Reviews section — appears after recs
        if (reviewsEl) {
          var revWrap = document.createElement('div');
          revWrap.id = 'zahav-panel-reviews';
          revWrap.className = 'zahav-panel-reviews';
          revWrap.appendChild(document.adoptNode(reviewsEl));
          content.appendChild(revWrap);

          // For products with no reviews the widget div is empty — show a prompt instead
          var widgetEl = revWrap.querySelector('.jdgm-widget');
          var hasReviews = revWrap.querySelector('.jdgm-legacy-widget-content');
          if (widgetEl && !hasReviews) {
            var noRevMsg = document.createElement('div');
            noRevMsg.className = 'zahav-panel-no-reviews';
            var productUrl = href;
            noRevMsg.innerHTML = '<p>No reviews yet.</p><a href="' + productUrl + '#jdgm-write-rev" class="zahav-panel-no-reviews__cta">Be the first to review</a>';
            revWrap.appendChild(noRevMsg);
          }

          // Judge.me ships the review HTML inside .jdgm-legacy-widget-content (display:none)
          // with a temp <style> that also hides .jdgm-rev-widg. The JS would normally
          // unhide these, but it won't re-run for dynamically injected DOM — so we do it.
          revWrap.querySelectorAll('.jdgm-temp-hiding-style').forEach(function(s) { s.remove(); });
          revWrap.querySelectorAll('.jdgm-legacy-widget-content').forEach(function(el) {
            el.style.display = '';
          });
          revWrap.querySelectorAll('.jdgm-rev-widg').forEach(function(el) {
            el.style.display = '';
          });
          // Timestamps: JS normally converts data-content to a relative date string
          // and removes the jdgm-spinner class. Do it manually.
          revWrap.querySelectorAll('.jdgm-rev__timestamp.jdgm-spinner[data-content]').forEach(function(el) {
            var raw = el.getAttribute('data-content');
            if (!raw) return;
            try {
              var d = new Date(raw);
              var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
              el.textContent = months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
            } catch(e) { el.textContent = raw.split(' ')[0]; }
            el.classList.remove('jdgm-spinner');
          });
          // Histogram: remove jdgm-temp-hidden so the bar chart shows
          revWrap.querySelectorAll('.jdgm-histogram.jdgm-temp-hidden').forEach(function(el) {
            el.classList.remove('jdgm-temp-hidden');
          });
          // Lazy images: Judge.me uses data-src for review photos; swap to src
          revWrap.querySelectorAll('img[data-src]').forEach(function(img) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          });
          // Review photo lightbox: intercept clicks on photo links — show overlay instead of navigating
          revWrap.addEventListener('click', function(e) {
            var a = e.target.closest('a[href]');
            if (!a) return;
            var href = a.getAttribute('href');
            if (!href || !/judgeme\.imgix\.net|cdn\.judge\.me|cdn\.shopify\.com/.test(href)) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            var overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.85);display:flex;align-items:center;justify-content:center;cursor:zoom-out';
            var img = document.createElement('img');
            img.src = href;
            img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:4px';
            overlay.appendChild(img);
            overlay.addEventListener('click', function() { overlay.remove(); });
            document.body.appendChild(overlay);
          });
          // Hide Judge.me's built-in paginator — we handle loading via infinite scroll
          revWrap.querySelectorAll('.jdgm-paginate, .jdgm-rev-widg__paginate-spinner-wrapper').forEach(function(el) {
            el.style.display = 'none';
          });

          // Infinite scroll: load more reviews via Judge.me API as user scrolls
          (function() {
            var widgetEl2 = revWrap.querySelector('.jdgm-widget[data-id]');
            if (!widgetEl2) return;
            var productId = widgetEl2.getAttribute('data-id');
            var reviewsBody = revWrap.querySelector('.jdgm-rev-widg__body .jdgm-rev-widg__reviews');
            if (!productId || !reviewsBody) return;

            var currentPage = 1;
            var totalPages = 1; // will be updated from first API response
            var loading = false;
            var perPage2 = 5;

            // Sentinel element at the bottom of the reviews list — when it enters the
            // panel viewport, load the next page
            var sentinel = document.createElement('div');
            sentinel.className = 'zahav-reviews-sentinel';
            reviewsBody.parentElement.appendChild(sentinel);

            var months2 = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

            function formatDate(str) {
              try {
                var d = new Date(str);
                return months2[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
              } catch(e) { return str; }
            }

            function renderStars(rating) {
              var html = '';
              for (var i = 1; i <= 5; i++) {
                html += '<span class="jdgm-star ' + (i <= rating ? 'jdgm--on' : 'jdgm--off') + '"></span>';
              }
              return html;
            }

            function renderReview(r) {
              // pictures_urls is an array of objects: {original, small, compact, huge}
              var pics = '';
              if (r.pictures_urls && r.pictures_urls.length) {
                pics = '<div class="jdgm-rev__pics">';
                r.pictures_urls.forEach(function(pic) {
                  var thumb = pic.compact || pic.small || pic.original || '';
                  var full  = pic.original || pic.huge || thumb;
                  if (thumb) pics += '<a href="' + full + '"><img src="' + thumb + '" class="jdgm-rev__pic-img" loading="lazy"></a>';
                });
                pics += '</div>';
              }
              // Use zahav-rev__verified instead of jdgm-rev__buyer-badge so Judge.me's
              // CSS ::before "Verified" pseudo-element doesn't double up with our text
              var badge = r.verified_buyer
                ? '<span class="zahav-rev__verified">Verified</span>'
                : '';
              return '<div class="jdgm-rev jdgm-divider-top zahav-rev-api">' +
                '<div class="jdgm-rev__header">' +
                  '<span class="jdgm-rev__rating" data-score="' + r.rating + '">' + renderStars(r.rating) + '</span>' +
                  '<span class="jdgm-rev__timestamp">' + formatDate(r.created_at) + '</span>' +
                  '<div class="jdgm-rev__br"></div>' +
                  badge +
                  '<span class="jdgm-rev__author-wrapper"><span class="jdgm-rev__author">' + (r.reviewer_name || '') + '</span></span>' +
                '</div>' +
                '<div class="jdgm-rev__content">' +
                  (r.title ? '<b class="jdgm-rev__title">' + r.title + '</b>' : '') +
                  '<div class="jdgm-rev__body">' + (r.body_html || '') + '</div>' +
                  pics +
                '</div>' +
              '</div>';
            }

            function loadNextPage() {
              if (loading || currentPage >= totalPages) return;
              loading = true;
              sentinel.classList.add('zahav-reviews-sentinel--loading');
              var nextPage = currentPage + 1;
              var apiUrl = 'https://api.judge.me/reviews/reviews_for_widget?' +
                'shop_domain=zahav-jewelry-2.myshopify.com' +
                '&url=zahav-jewelry-2.myshopify.com' +
                '&platform=shopify' +
                '&per_page=' + perPage2 +
                '&product_id=' + productId +
                '&page=' + nextPage;
              fetch(apiUrl)
                .then(function(r) { return r.json(); })
                .then(function(data) {
                  currentPage = data.pagination.current_page;
                  totalPages = data.pagination.total_pages;
                  (data.reviews || []).forEach(function(rev) {
                    reviewsBody.insertAdjacentHTML('beforeend', renderReview(rev));
                  });
                  if (currentPage >= totalPages) sentinel.remove();
                })
                .catch(function() {})
                .finally(function() {
                  loading = false;
                  sentinel.classList.remove('zahav-reviews-sentinel--loading');
                });
            }

            // Also get total pages from the widget data script if available
            var dataScript = revWrap.querySelector('[data-number-of-reviews]');
            if (dataScript) {
              var tot = parseInt(dataScript.getAttribute('data-number-of-reviews'), 10) || 0;
              totalPages = Math.ceil(tot / perPage2);
            }

            // Use IntersectionObserver to trigger load when sentinel is visible
            var panelEl = document.getElementById('zahav-panel-content');
            if (!panelEl) return;
            var observer = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) loadNextPage();
              });
            }, { root: panelEl, rootMargin: '200px' });
            observer.observe(sentinel);
          })();
          // Also attempt the Judge.me public API in case the new widget loader is in use
          setTimeout(function() {
            if (window.jdgm && typeof window.jdgm.customWidgets === 'function') {
              window.jdgm.customWidgets(revWrap);
            } else if (window.jdgm && typeof window.jdgm.init === 'function') {
              window.jdgm.init();
            }
          }, 100);
        }

        // Populate recommendations manually (product-recommendations.js not loaded on collection page)
        var recsTarget = recsWrap.querySelector('product-recommendations');
        if (recsTarget && recsTarget.dataset.url && recsTarget.dataset.sectionId && recsTarget.dataset.productId) {
          var recsUrl = recsTarget.dataset.url + '&section_id=' + recsTarget.dataset.sectionId + '&product_id=' + recsTarget.dataset.productId;
          if (recsTarget.dataset.intent) {
            recsUrl += '&intent=' + recsTarget.dataset.intent;
          }
          fetch(recsUrl, { credentials: 'same-origin' })
            .then(function(r) { return r.ok ? r.text() : ''; })
            .then(function(recsHtml) {
              if (!recsHtml) return;
              var rd = new DOMParser().parseFromString(recsHtml, 'text/html');
              var rc = rd.querySelector('product-recommendations');
              if (rc && recsTarget) recsTarget.innerHTML = rc.innerHTML;
            }).catch(function() {});
        }

        // Lightbox — find img from click target or its descendants/ancestor container
        mWrap.addEventListener('click', function(e) {
          var img = e.target.tagName === 'IMG' ? e.target : (e.target.querySelector && e.target.querySelector('img'));
          if (!img) {
            var item = e.target.closest && e.target.closest('.product-media-gallery__item, li');
            if (item) img = item.querySelector('img');
          }
          if (!img) return;
          e.preventDefault();
          // Use highest-resolution srcset entry if available
          var src = '';
          if (img.srcset) {
            var best = img.srcset.split(',').map(function(s) {
              var p = s.trim().split(/\s+/);
              return { url: p[0], w: parseInt(p[1]) || 0 };
            }).sort(function(a, b) { return b.w - a.w; })[0];
            if (best && best.url) src = best.url;
          }
          if (!src) src = img.currentSrc || img.src || img.getAttribute('src') || '';
          if (!src) return;
          var lb = document.createElement('div');
          lb.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(30,25,22,0.96);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
          var lbImg = document.createElement('img');
          lbImg.src = src;
          lbImg.style.cssText = 'max-width:92vw;max-height:92vh;object-fit:contain;';
          lb.appendChild(lbImg);
          function closeLb() { lb.remove(); document.removeEventListener('keydown', escLb); }
          function escLb(ev) { if (ev.key === 'Escape') closeLb(); }
          lb.addEventListener('click', closeLb);
          document.addEventListener('keydown', escLb);
          document.body.appendChild(lb);
        });
      })
      .catch(function() { content.innerHTML = '<div style="padding:2rem">Could not load product.</div>'; });
  }

  function fullyClosePanel() {
    if (!isOpen) return;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('zahav-panel-open');
    isOpen = false;
    currentHref = null;
    panelHistory = [];
    if (exitBtn) exitBtn.hidden = true;
    content.innerHTML = '';
    var ps = document.getElementById('zahav-panel-page-styles');
    if (ps) ps.remove();
    var dest = window.location.href.replace(/#panel$/, '').replace(/#panel/, '');
    history.pushState(null, '', dest);
  }

  function goBack() {
    if (!isOpen) return;
    if (panelHistory.length > 0) {
      var prev = panelHistory.pop();
      currentHref = null;
      openPanel(prev);
    } else {
      fullyClosePanel();
    }
  }

  backdrop.addEventListener('click', fullyClosePanel);
  closeBtn.addEventListener('click', goBack);
  if (exitBtn) exitBtn.addEventListener('click', fullyClosePanel);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) fullyClosePanel();
  });

  window.addEventListener('popstate', function(e) {
    if (isOpen) {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zahav-panel-open');
      isOpen = false;
      currentHref = null;
      panelHistory = [];
      if (exitBtn) exitBtn.hidden = true;
      content.innerHTML = '';
    }
  });

  function isProductLink(a) {
    try {
      var url = new URL(a.href, window.location.origin);
      return url.origin === window.location.origin && /^\/products\/[^\/]+\/?$/.test(url.pathname);
    } catch(e) { return false; }
  }

  document.addEventListener('click', function(e) {
    // Gallery media handles its own clicks (lightbox); don't intercept them
    if (e.target.closest('.zahav-panel-grid__media')) return;
    var a = e.target.closest('a[href]');
    if (!a || !isProductLink(a)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (/^\/products\//.test(window.location.pathname)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    a.removeAttribute('target');
    // Close any open Judge.me modal first, then open the panel
    var jdgmModal = document.querySelector('.jdgm-modal, [class*="jdgm-modal"]');
    if (jdgmModal) {
      var closeBtn = jdgmModal.querySelector('[class*="close"], [class*="dismiss"], button');
      if (closeBtn) closeBtn.click();
      else jdgmModal.style.display = 'none';
    }
    // Clicking a product result inside the search dialog hits this same interceptor (it's
    // still just an <a href="/products/...">), so the dialog never gets a real navigation
    // to close it on - close it explicitly here instead.
    var searchDialog = document.getElementById('search-modal');
    var searchDialogEl = searchDialog && searchDialog.querySelector('dialog');
    if (searchDialogEl && searchDialogEl.open) searchDialogEl.close();
    openPanel(a.href);
  }, true);
})();
